module.exports = __webpack_public_path__ + "img/full6-min.351479fc.png";